<app-frame-3
  appPageTitle="Sitemule - Download Sitemule Model Studio"
  appFavicon="../../../../assets/images/sitemule-logo.png"
  [links]="topNavigation"
  [content]="content"
  [contacts]="contacts"
  logo="sitemulelogo"
  logoLink="/"
  logoName="Sitemule"
  logoSlogan="evolve your business while holding on to the core"
  logoSloganMobile="evolve your business"
  [breadcrumb]="breadcrumb"
  copyRightInfo="Sitemule is a trademark by System & Method A/S. All rights reserved ©2022"
>
  <div class="description-container-section">
    <div class="main-container">
      <h1>Download Sitemule Model Studio</h1>
      <div class="booking-section">
        <p class="sub-heading">
          Thank you for your interest in Sitemule Model Studio.
          <br />
          We're excited to announce an exclusive opportunity while we finalize
          our new software hub!
        </p>
        <div class="booking">
          <a href="mailto:{{ mail }}{{ mailInfo }}">
            <span smSvgIcon="calendar"></span>
            <p>Book installation & demo</p>
          </a>
          <div (click)="showYoutubeModal()">
            <span smSvgIcon="play"></span>
            <p>Presentation</p>
          </div>
        </div>
      </div>
      <div class="description-section">
        <p>
          We're currently hard at work perfecting our download and automated
          setup procedures to ensure that Sitemule Model Studio offers a
          seamless experience. As a result, the public download option won't be
          available until the beginning of 2024.
        </p>

        <p>
          However, we don't want you to wait idly. Instead, we'd like to invite
          you to be part of an exclusive event where you can have Sitemule Model
          Studio installed on your system ahead of the official release. This
          unique opportunity allows us to gather valuable feedback and insights,
          enabling us to further enhance your user experience.
        </p>
        <div>
          <h3>Personalized installation and demo</h3>
          <p>
            As a token of our appreciation for your participation, we'll provide
            you with a personalized guided tour of the software and assist you
            in creating your very first application using Sitemule Model Studio.
            This hands-on experience will give you a head start in harnessing
            the full potential of our software.
          </p>
        </div>

        <p>
          If you're as excited as we are and would like to book a session for
          installation and a guided tour, please contact us at
          <a href="mailto:{{ mail }}{{ mailInfo }}">{{ mail }}</a>
          . We truly value your understanding and cooperation as we work towards
          delivering a top-notch software solution.
        </p>
        <p>
          Thank you for being part of this exciting journey with us, and we look
          forward to hearing from you soon. Together, we'll shape the future of
          Sitemule Model Studio!
        </p>
      </div>
    </div>
  </div>

  <app-youtube-modal
    #youtubeRef
    [linkModal]="true"
    [youtubeLink]="'https://www.youtube.com/watch?v=2YJU3HRV3EY'"
  ></app-youtube-modal>

  <div
    class="product-demo-show"
    [style]="{
      '--bg-image': 'url(../../../../assets/images/sitemule-model-studio.png)'
    }"
  ></div>

  <sm-container
    id="team"
    class="app-persons"
    [style]="{
      '--max-content-width': '1500px',
      backgroundColor: '#CED7D7',
      paddingBlock: '250px',
      minHeight: '100vh'
    }"
  >
    <app-persons
      id="sitemule-team"
      header="Meet the Sitemule Team"
      [allPersons]="allPersons"
      [style.--header-text-color]="'#969EA7'"
      [style.--text-color]="'#3e4854'"
      [style.--person-background-color]="'#FBFBFB'"
      [style.--person-column-number]="3"
    ></app-persons>
  </sm-container>

  <sm-container
    class="app-coffee"
    [style]="{
      backgroundColor: '#1790F4',
      minHeight: '941px'
    }"
  >
    <div class="coffee-section">
      <app-image-animation
        altText="coffee cup text"
        imagePath="../../../../assets/images/coffee-cup.png"
      ></app-image-animation>
      <h1>Let's talk</h1>
      <p class="note">
        No sales BS. Just about making business better through technology.
      </p>
      <div class="links-container center" sm-technical-button>
        <a
          routerLink="/download"
          fragment="lets-have-a-talk"
          [style.--border-radius]="'28px'"
          [style.--background-color]="'#FFFFFF'"
          [style.--hover-background-color]="'#EEEEEE'"
          [style.--button-text-color]="'#1790F4'"
          [style.--button-font-weight]="500"
        >
          Start here
        </a>
      </div>
    </div>
  </sm-container>

  <sm-container
    id="lets-have-a-talk"
    class="contact-form"
    [style]="{
      backgroundColor: '#ebeced'
    }"
  >
    <app-contact-form
      header="Contact"
      subHeader="We will respond within 24 hours"
      type="sitemule"
    ></app-contact-form>
  </sm-container>
</app-frame-3>
